//
//
//
//
//
//
//
//
//
//
//
//

import  InTitle  from './title'
import  Editor  from '@/views/stencil/components/editor'

    export default {
        name:'InDetails',
        data() {
            return{

            }
        },
        components: {
            InTitle,
            Editor
        },
        props: {
            claim: {
                type: Object,
                default(){
                    return {}
                }
            },
        },
    }
